import { render, staticRenderFns } from "./SuggestCafeItem.vue?vue&type=template&id=2fd12bc5&"
import script from "./SuggestCafeItem.vue?vue&type=script&lang=js&"
export * from "./SuggestCafeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/hanmail/src/cafe-top/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2fd12bc5', component.options)
    } else {
      api.reload('2fd12bc5', component.options)
    }
    module.hot.accept("./SuggestCafeItem.vue?vue&type=template&id=2fd12bc5&", function () {
      api.rerender('2fd12bc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/home/SuggestCafeItem.vue"
export default component.exports